<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header
            headerText="{{ l10nKeys.updateLabel | vtranslate }}"
            [showEditButton]="true"
            (onButtonClick)="editUpgradeProfile()"
        ></avi-page-header>
        <clr-tabs>
            <clr-tab>
                <button 
                    clrTabLink
                    uiSrefActive="active"
                    [uiSref]="stateNames.CONTROLLER_DETAIL_UPDATE_SYSTEM"
                >
                    {{ l10nKeys.systemLabel | vtranslate }}
                </button>
            </clr-tab>
            <clr-tab>
                <button 
                    clrTabLink
                    uiSrefActive="active"
                    [uiSref]="stateNames.CONTROLLER_DETAIL_UPDATE_SEG"
                >
                    {{ l10nKeys.segLabel | vtranslate }}
                </button>
            </clr-tab>
        </clr-tabs>
        <ui-view></ui-view>
    </avi-state-page_main-content>
</avi-state-page>
